var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5065_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.417 62.5L38.6856 69.0372C39.7918 71.2496 40.3449 72.3558 41.0838 73.3144C41.7395 74.165 42.502 74.9276 43.3526 75.5832C44.3112 76.3221 45.4174 76.8752 47.6298 77.9814L54.167 81.25L47.6298 84.5186C45.4174 85.6248 44.3112 86.1779 43.3526 86.9168C42.502 87.5725 41.7395 88.335 41.0838 89.1857C40.3449 90.1442 39.7918 91.2505 38.6856 93.4629L35.417 100L32.1484 93.4629C31.0422 91.2505 30.4891 90.1442 29.7502 89.1857C29.0945 88.335 28.332 87.5725 27.4814 86.9168C26.5228 86.1779 25.4166 85.6248 23.2041 84.5186L16.667 81.25L23.2041 77.9814C25.4166 76.8752 26.5228 76.3221 27.4814 75.5832C28.332 74.9276 29.0945 74.165 29.7502 73.3144C30.4891 72.3558 31.0422 71.2496 32.1484 69.0372L35.417 62.5Z",
    stroke: "#4D7DB4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8337 16.6667L75.7446 29.4351C76.9196 32.4902 77.5072 34.0178 78.4208 35.3027C79.2306 36.4415 80.2255 37.4365 81.3643 38.2462C82.6492 39.1599 84.1768 39.7474 87.2319 40.9224L100 45.8334L87.2319 50.7443C84.1768 51.9193 82.6492 52.5068 81.3643 53.4205C80.2255 54.2302 79.2306 55.2252 78.4208 56.364C77.5072 57.6489 76.9196 59.1765 75.7446 62.2316L70.8337 75L65.9227 62.2316C64.7477 59.1765 64.1602 57.6489 63.2465 56.364C62.4368 55.2252 61.4418 54.2302 60.303 53.4205C59.0181 52.5068 57.4905 51.9193 54.4354 50.7443L41.667 45.8334L54.4354 40.9224C57.4905 39.7474 59.0181 39.1599 60.303 38.2462C61.4418 37.4365 62.4368 36.4415 63.2465 35.3027C64.1602 34.0178 64.7477 32.4902 65.9227 29.4351L70.8337 16.6667Z",
    stroke: "#4D7DB4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5065_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.d1759e554d35a8e4083f211d3716edec.svg";
export { ForwardRef as ReactComponent };